import { useSearchParams } from 'react-router';

export function useDebugNewMobileSearch(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.has('mobileSearchV2');
}
